export default __webpack_public_path__ + "static/3-2-cms-e38e6f6f1999659d0ef9f46dd0cf830c.gif";